<template>
  <div>
    <b-table
      :fields="fields"
      :items="$store.getters.blackList"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      data-checkbox="true"
      sticky-header
      head-variant="dark"
      hover
      small
      striped
    >
      <template v-slot:cell(account)="{ item }">
        <a @click="toUserDetail(item)">{{ item.account }}</a>
      </template>
      <template v-slot:cell(reject_btn)="{ item }">
        <button @click="summit(item)">恢復</button>
      </template>
    </b-table>
    <tableListNoData
      v-if="$store.getters.blackList.length === 0"
    ></tableListNoData>
  </div>
</template>

<script>
import tableListNoData from "@/components/TableListNoData.vue";
export default {
  components: {
    tableListNoData
  },
  data() {
    return {
      sortBy: "created_at",
      sortDesc: false,
      fields: [
        { key: "account", label: "帳號", sortable: true },
        { key: "name", label: "姓名", sortable: true },
        { key: "email", label: "信箱", sortable: true },
        { key: "phone", label: "電話", sortable: true },
        { key: "created_at", label: "申請時間", sortable: true },
        { key: "reject_btn", label: "", sortable: false }
      ]
    };
  },
  methods: {
    toUserDetail(item) {
      this.$store.commit("userDetail", item);
      this.$router.push({ name: "userDetail", params: { userId: item.id } });
    },
    async summit(item) {
      await this.$store.dispatch("deleteBlackUser", item);
      location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .table-hover tbody tr:hover {
  background-color: #343a40;
  color: #fff;
}
::v-deep .table tbody tr a {
  display: inline-block;
  width: 100%;
  cursor: pointer;
}
</style>
